<template>
  <div class="fb fb-row fb-cross-center rail-box" @click="audioPlay">
    <div class="iconfont font-32 c-171A1D mr-9">{{
      status ? '&#xe705;' : '&#xe6d3;'
    }}</div>
    <div class="rail relative" :style="{ width: `${railW}px` }">
      <div
        class="iconfont font-32 c-171A1D absolute rail-process"
        :style="{ left: `${pleft}px` }"
        >&#xe64b;</div
      >
    </div>
    <div class="font-26 c-171A1D-85 ml-12">{{ now }}:{{ duration }}</div>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    item: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data() {
    return {
      status: false, // false 可播放  true可暂停
      time: 0,
      now: `00`,
      duration: `00`,
      pleft: 0,
      itvl: null,
      railW: 150
    }
  },
  computed: {},
  watch: {
    item: {
      handler(v) {
        this.status = v.audioState
        this.time = (this.item || {}).audioSeconds || 0
        this.duration = `0${this.time}`.replace(/(.*)(\d{2})/, '$2')
        if (!this.status) {
          this.initAduio()
        }
      },
      deep: true
    },
    now() {
      if (this.now === this.duration) {
        this.initAduio()
      }
    }
  },
  beforeCreate() {},
  created() {},
  beforeMount() {},
  mounted() {
    this.initAduio()
  },
  beforeUpdate() {},
  updated() {},
  activated() {},
  deactivated() {},
  beforeDestroy() {},
  destroyed() {},
  methods: {
    // 播放语音
    audioPlay() {
      if (this.duration === '00') {
        return
      }
      this.status = !this.status
      if (this.status) {
        const _segs = 10
        const _times = (+this.time * 1000) / _segs
        const _unitW = (this.railW - 12) / _times
        let _n = 0
        this.itvl = setInterval(() => {
          _n++
          if (_n >= _times) {
            clearInterval(this.itvl)
          }
          const _now = Math.floor((_n * _segs) / 1000)
          this.$nextTick(() => {
            // 轨道点
            this.pleft = _n * _unitW
            this.now = `0${_now}`.replace(/(.*)(\d{2})/, '$2')
            // 播放完 回
          })
        }, _segs)
      } else {
        this.initAduio()
      }
      this.$emit('click', this.status, this.item)
    },
    // 初始化audio
    initAduio() {
      this.time = (this.item || {}).audioSeconds || 0
      this.duration = `0${this.time}`.replace(/(.*)(\d{2})/, '$2')
      this.now = `00`
      this.pleft = 0
      this.status = false
      clearInterval(this.itvl)
    }
  }
}
</script>

<style lang="scss" scoped>
.rail-box {
  width: 220px;
  height: 16px;
}
.rail {
  height: 2px;
  background: #d8d8d8;
  border-radius: 1px;
}
.rail-process {
  top: -11px;
  left: 0;
  transition-timing-function: linear;
}
</style>
